import { render, staticRenderFns } from "./RegisterSchoolFree.vue?vue&type=template&id=5d6c1ef6"
import script from "./RegisterSchoolFree.vue?vue&type=script&lang=ts"
export * from "./RegisterSchoolFree.vue?vue&type=script&lang=ts"
import style0 from "./RegisterSchoolFree.vue?vue&type=style&index=0&id=5d6c1ef6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports